document.addEventListener('change', function (e) {
  const select = e.target.closest('[data-tal-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const wrapper = select.closest('[data-tal-product-form]');
  const button = wrapper && wrapper.querySelector('[data-tal-add]');
  const price = document.querySelector('[data-tal-dynamic-price]');
  if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'SOLD OUT' : 'ADD TO BAG'; }
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});
